// 配置文件
export const config = [
  {
    path: "loading",
    nextPath: "loop"
  },
  {
    path: "01", //路径下标
    condition: 1,
    choices: {
      choicesTxt: "面对邀请，你——",
      choicesArr: [
        {
          choicesBtn: "没有兴致",
          nextPath: "02A"
        },
        {
          choicesBtn: "欣然答应",
          nextPath: "02B"
        }
      ]
    }
  },
  {
    path: "02A",
    condition: 1,
    choices: {
      choicesTxt: "是否采取保护措施？你觉得——",
      choicesArr: [
        {
          choicesBtn: "保险点好",
          nextPath: "03A"
        },
        {
          choicesBtn: "没事儿的",
          nextPath: "03B"
        }
      ]
    }
  },
  {
    path: "02B",
    condition: 1,
    choices: {
      choicesTxt: "是否采取保护措施？你觉得——",
      choicesArr: [
        {
          choicesBtn: "保险点好",
          nextPath: "03A"
        },
        {
          choicesBtn: "没事儿的",
          nextPath: "03B"
        }
      ]
    }
  },

  {
    path: "03A",
    condition: 1,
    choices: {
      choicesTxt: "看到手机弹窗，你——",
      choicesArr: [
        {
          choicesBtn: "立刻关掉",
          nextPath: "04A"
        },
        {
          choicesBtn: "观看广告",
          nextPath: "04B"
        }
      ]
    }
  },
  {
    path: "03B",
    condition: 1,
    choices: {
      choicesTxt: "看到手机弹窗，你——",
      choicesArr: [
        {
          choicesBtn: "立刻关掉",
          nextPath: "04A"
        },
        {
          choicesBtn: "观看广告",
          nextPath: "04B"
        }
      ]
    }
  },
  {
    path: "04A",
    condition: 1,
    choices: {
      choicesTxt: "面对诊断结果，你——",
      choicesArr: [
        {
          choicesBtn: "咨询问题",
          nextPath: "05A"
        },
        {
          choicesBtn: "静一会儿",
          nextPath: "05B"
        }
      ]
    }
  },
  {
    path: "04B",
    condition: 1,
    choices: {
      choicesTxt: "面对诊断结果，你——",
      choicesArr: [
        {
          choicesBtn: "咨询问题",
          nextPath: "05A"
        },
        {
          choicesBtn: "静一会儿",
          nextPath: "05B"
        }
      ]
    }
  },
  {
    path: "05A",
    condition: 2,
    conditionTime: 71,
    // conditionTime: 66,
    nextPath: "end",
    choices: {
      choicesTxt: "即使感染了HIV，你相信——",
      choicesArr: [
        {
          choicesBtn: "生无畏，积极面对",
          nextPath: "05A"
        }
      ]
    }
  },
  {
    path: "05B",
    condition: 2,
    conditionTime: 63,
    nextPath: "end",
    choices: {
      choicesTxt: "即使感染了HIV，你相信——",
      choicesArr: [
        {
          choicesBtn: "生无畏，积极面对",
          nextPath: "05B"
        }
      ]
    }
  },
  {
    path: "05A",
    nextPath: "end"
  },
  {
    path: "05B",
    nextPath: "end"
  }
];
export const srcPath = {
  loading: "http://publics3.gileadchina.cn/video/hiv1912/loading.mp4",

  "01": "http://publics3.gileadchina.cn/video/hiv1912/small/01.mp4",
  "02A": "http://publics3.gileadchina.cn/video/hiv1912/small/02A.mp4",
  "02B": "http://publics3.gileadchina.cn/video/hiv1912/small/02B.mp4",
  "03A": "http://publics3.gileadchina.cn/video/hiv1912/small/03A.mp4",
  "03B": "http://publics3.gileadchina.cn/video/hiv1912/small/03B.mp4",
  "04A": "http://publics3.gileadchina.cn/video/hiv1912/small/04A.mp4",
  "04B": "http://publics3.gileadchina.cn/video/hiv1912/small/04B.mp4",
  "05A": "http://publics3.gileadchina.cn/video/hiv1912/small/05A1.mp4",
  // "05A": "http://publics3.gileadchina.cn/video/hiv1912/small/05A.mp4",
  "05B": "http://publics3.gileadchina.cn/video/hiv1912/small/05B.mp4"
};
// export const srcPath = {
//   loading: require("@video/loading.mp4"),
//   "01": require("@video/01.mp4"),
//   "02A": require("@video/02A.mp4"),
//   "02B": require("@video/02B.mp4"),
//   "03A": require("@video/03A.mp4"),
//   "03B": require("@video/03B.mp4"),
//   "04A": require("@video/04A.mp4"),
//   "04B": require("@video/04B.mp4"),
//   "05A": require("@video/05A.mp4"),
//   "05B": require("@video/05B.mp4")
// };
export const messageArr = [
  {
    path: "04A", //视频名称
    time: 18, //播放时间s
    x: 20,
    y: 70,
    keep: 6, //显示时间s
    txt: "感染HIV的高危行为",
    msg:
      "<div style='padding-left:0.3rem;white-space: pre-wrap;' class='por'><i style='width:0.1rem;height:0.1rem;position:absolute;left:0;top:0.24rem;background: #fff;border-radius: 50%;'></i><span>无保护的性行为</span></div><div style='padding-left:0.3rem;white-space: pre-wrap;' class='por'><i style='width:0.1rem;height:0.1rem;position:absolute;left:0;top:0.24rem;background: #fff;border-radius: 50%;'></i><span>已感染其它性传播疾病</span></div><div style='padding-left:0.3rem;white-space: pre-wrap;' class='por'><i style='width:0.1rem;height:0.1rem;position:absolute;left:0;top:0.24rem;background: #fff;border-radius: 50%;'></i><span>注射吸毒时共用受污染的注射器具及药品</span></div><div style='padding-left:0.3rem;white-space: pre-wrap;' class='por'><i style='width:0.1rem;height:0.1rem;position:absolute;left:0;top:0.24rem;background: #fff;border-radius: 50%;'></i><span>接受不安全的注射、输血、组织移植以及未充分消毒的切割或穿刺医疗程序</span></div><div style='padding-left:0.3rem;white-space: pre-wrap;' class='por'><i style='width:0.1rem;height:0.1rem;position:absolute;left:0;top:0.24rem;background: #fff;border-radius: 50%;'></i><span>卫生人员不慎被针具刺伤</span></div>"
  },
  {
    path: "04B", //视频名称
    time: 2, //播放时间
    x: 20,
    y: 64,
    keep: 8, //显示时间
    txt: "感染HIV的高危行为",
    msg:
      "<div style='padding-left:0.3rem;white-space: pre-wrap;' class='por'><i style='width:0.1rem;height:0.1rem;position:absolute;left:0;top:0.24rem;background: #fff;border-radius: 50%;'></i><span>无保护的性行为</span></div><div style='padding-left:0.3rem;white-space: pre-wrap;' class='por'><i style='width:0.1rem;height:0.1rem;position:absolute;left:0;top:0.24rem;background: #fff;border-radius: 50%;'></i><span>已感染其它性传播疾病</span></div><div style='padding-left:0.3rem;white-space: pre-wrap;' class='por'><i style='width:0.1rem;height:0.1rem;position:absolute;left:0;top:0.24rem;background: #fff;border-radius: 50%;'></i><span>注射吸毒时共用受污染的注射器具及药品</span></div><div style='padding-left:0.3rem;white-space: pre-wrap;' class='por'><i style='width:0.1rem;height:0.1rem;position:absolute;left:0;top:0.24rem;background: #fff;border-radius: 50%;'></i><span>接受不安全的注射、输血、组织移植以及未充分消毒的切割或穿刺医疗程序</span></div><div style='padding-left:0.3rem;white-space: pre-wrap;' class='por'><i style='width:0.1rem;height:0.1rem;position:absolute;left:0;top:0.24rem;background: #fff;border-radius: 50%;'></i><span>卫生人员不慎被针具刺伤</span></div>"
  },
  {
    path: "04A", //视频名称
    time: 27, //播放时间
    x: 20,
    y: 70,
    keep: 6, //显示时间
    txt: "尽快阻断，不超过72小时！",
    msg:
      "在发生可能感染的行为后及时进行暴露后预防，可降低艾滋病感染风险达89%。暴露后预防的疗程一般是28天，第一剂药物应在高危行为后72小时内尽早应用，2小时内为最佳时机。"
  },
  {
    path: "04B", //视频名称
    time: 13, //播放时间
    x: 20,
    y: 64,
    keep: 9, //显示时间
    txt: "尽快阻断，不超过72小时！",
    msg:
      "在发生可能感染的行为后及时进行暴露后预防，可降低艾滋病感染风险达89%。暴露后预防的疗程一般是28天，第一剂药物应在高危行为后72小时内尽早应用，2小时内为最佳时机。"
  },
  {
    path: "04A", //视频名称
    time: 41, //播放时间
    x: 20,
    y: 72,
    keep: 5, //显示时间
    txt: "为何要再查一次？",
    msg:
      "大多数人会在感染21天之内产生针对艾滋病毒的抗体，因此在感染早期可能检测不到抗体。病毒在最早感染期时感染性最强，不过在所有感染期都可能发生艾滋病毒传播。<br/><br/>为了排除可能出现的任何检测或者报告错误，在将所有最初诊断为艾滋病毒阳性人员纳入到治疗方案之前实施重复检测，也属于最佳实践做法。需要特别注意的是，一旦人们确诊了艾滋病毒诊断并启动治疗，就不应对他们进行重复检测。"
  },
  {
    path: "04B", //视频名称
    time: 28, //播放时间
    x: 20,
    y: 72,
    keep: 5, //显示时间
    txt: "为何要再查一次？",
    msg:
      "大多数人会在感染21天之内产生针对艾滋病毒的抗体，因此在感染早期可能检测不到抗体。病毒在最早感染期时感染性最强，不过在所有感染期都可能发生艾滋病毒传播。<br/><br/>为了排除可能出现的任何检测或者报告错误，在将所有最初诊断为艾滋病毒阳性人员纳入到治疗方案之前实施重复检测，也属于最佳实践做法。需要特别注意的是，一旦人们确诊了艾滋病毒诊断并启动治疗，就不应对他们进行重复检测。"
  },

  {
    path: "04A", //视频名称
    time: 67, //播放时间
    x: 10,
    y: 67,
    keep: 9, //显示时间
    txt: "HIV阳性≠艾滋病患者",
    msg:
      "艾滋病是HIV感染最晚期/较严重的时期，确诊感染HIV后，应尽快接受治疗，控制病情，降低艾滋病发病率。"
  },
  {
    path: "04B", //视频名称
    time: 53, //播放时间
    x: 10,
    y: 67,
    keep: 9, //显示时间
    txt: "HIV阳性≠艾滋病患者",
    msg:
      "艾滋病是HIV感染最晚期/较严重的时期，确诊感染HIV后，应尽快接受治疗，控制病情，降低艾滋病发病率。"
  },
  // {
  //   path: "05A", //视频名称
  //   time: 2, //播放时间
  //   x: 20,
  //   y: 70,
  //   keep: 18, //显示时间
  //   txt: "感染HIV后",
  //   msg:
  //     "建议积极调整心态，尽快接受治疗，控制病情，同时参加相关社会组织的感染者关爱活动。"
  // },
  // {
  //   path: "05B", //视频名称
  //   time: 6, //播放时间
  //   x: 20,
  //   y: 70,
  //   keep: 12, //显示时间
  //   txt: "感染HIV后",
  //   msg:
  //     "建议积极调整心态，尽快接受治疗，控制病情，同时参加相关社会组织的感染者关爱活动。"
  // },
  {
    path: "05A", //视频名称
    time: 90, //播放时间
    x: 20,
    y: 68,
    keep: 9, //显示时间
    txt: "感染HIV≠失去正常生活",
    msg:
      "HIV感染者在接受抗病毒治疗后，血液中病毒载量如果连续6个月小于200拷贝/ml且持续保持，经性行为传染给其性伴侣的风险几乎可以忽略不计。"
  },
  {
    path: "05B", //视频名称
    time: 82, //播放时间
    x: 20,
    y: 68,
    keep: 9, //显示时间
    txt: "感染HIV≠失去正常生活",
    msg:
      "HIV感染者在接受抗病毒治疗后，血液中病毒载量如果连续6个月小于200拷贝/ml且持续保持，经性行为传染给其性伴侣的风险几乎可以忽略不计。"
  }
];
